<template>
  <b-modal v-model="show" :title="title" hide-footer @shown="loadCities">
    <div class="custom-form">
      <div class="form-group">
        <label>Ciudad *</label>
        <select v-model="cityId" class="custom-form-control">
          <option :value="null" disabled>Seleccionar ciudad</option>
          <option v-for="c in cities" :key="c.id" :value="c.id">{{ c.name }}</option>
        </select>
        <small v-if="error" class="text-danger d-block mt-1">{{ error }}</small>
      </div>
      <div class="text-right mt-3">
        <b-button variant="none" class="button button-light mr-2" @click="show = false">Cancelar</b-button>
        <b-button variant="none" class="button button-primary" @click="confirm">Confirmar</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { GeographyService } from '@/core/services'

export default {
  name: 'CityAssignModal',
  props: {
    value: { type: Boolean, default: false },   // v-model = visibilidad
    title: { type: String, default: 'Asignar ciudad' }
  },
  data() {
    return { cities: [], cityId: null, error: null }
  },
  computed: {
    show: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    }
  },
  methods: {
    async loadCities() {
      this.error = null
      this.cityId = null
      if (this.cities.length) return
      try {
        const res = await GeographyService.listCities()
        this.cities = res.payload || []
      } catch (e) {
        console.error(e)
        this.error = 'No se pudieron cargar las ciudades'
      }
    },
    confirm() {
      if (!this.cityId) { this.error = 'Selecciona una ciudad'; return }
      this.$emit('confirm', this.cityId)
      this.show = false
    }
  }
}
</script>
